import task from "./task"
import scheduler from "./scheduler"

const baseUrl = "/api/inspect/";
export default {
    task, scheduler

}